module.exports = __webpack_public_path__ + "static/media/S.013c2b76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/S.svg
// module id = ./src/App/assets/S.svg
// module chunks = 0